import { IDangerClass248 } from 'APIPackage/DictionariesModule/interfaces/IDangerClass248';

import { makeCreateDictionarySelectOption } from './makeCreateDictionarySelectOption';

export const createDictionaryDangerClassSelectOption = makeCreateDictionarySelectOption<IDangerClass248>('id', 'title');
